"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accallioLibInfo = exports.getEnv = void 0;
/* eslint-disable import/prefer-default-export */
function getEnv(defaults) {
    var env = window.env;
    // console.log('getEnv()', env, defaults);
    if (env !== undefined) {
        var returnEnv = __assign(__assign({}, defaults), env);
        // console.log('getEnv() -> ', returnEnv);
        return returnEnv;
    }
    return defaults;
}
exports.getEnv = getEnv;
exports.accallioLibInfo = {
    libVersion: LIB_VERSION,
    appVersion: APP_VERSION,
};
//# sourceMappingURL=env.js.map